import { ArrowUpRight, ShoppingCart, Smile, Globe, Award } from 'lucide-react';

const StatsSection = () => {
  const stats = [
    {
      icon: <ShoppingCart className="w-8 h-8" />,
      value: "12K",
      title: "Productos vendidos",
      description: "Nuestros clientes aprovechan las ofertas.",
      color: "bg-primary"
    },
    {
      icon: <Globe className="w-8 h-8" />,
      value: "100%",
      title: "Online",
      description: "Disfruta desde la comodidad de casa.",
      color: "bg-secondary"
    },
    {
      icon: <Smile className="w-8 h-8" />,
      value: "14K",
      title: "Clientes satisfechos",
      description: "Afirman su satisfacción con nosotros.",
      color: "bg-accent"
    },
    {
      icon: <Award className="w-8 h-8" />,
      value: "5+",
      title: "Años de experiencia",
      description: "Brindando servicio de calidad.",
      color: "bg-dark"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    <section className="relative py-20 overflow-hidden bg-main-bg">
      {/* Elementos decorativos */}
      <div
        className="absolute top-0 left-0 w-64 h-64 rounded-full -translate-x-1/2 -translate-y-1/2 bg-primary/10 blur-3xl"
      />
      
      <div className="max-w-7xl mx-auto px-4">
        <div
        >
          {/* Encabezado */}
          <div className="mb-16 text-center">
            <h2 className="text-4xl font-bold font-poppins text-primary-dark mb-4">
              Conoce nuestro crecimiento
              <span 
                className="ml-2 inline-block"
               
              >
                🚀
              </span>
            </h2>
            <p className="text-lg text-gray-600 font-montserrat max-w-2xl mx-auto">
              Gracias a nuestro enfoque en la calidad y el servicio al cliente, hemos visto un aumento notable en nuestra base de clientes.
            </p>
          </div>

          {/* Grid de estadísticas */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div
                key={index}
                
                className="p-8 rounded-2xl bg-section-bg relative overflow-hidden"
              >
                {/* Efecto de brillo al hover */}
                <div className="absolute inset-0 opacity-0 transition-opacity duration-300 hover:opacity-100">
                  <div className="absolute w-32 h-32 bg-gradient-to-r from-primary/20 to-transparent -rotate-45 -top-8 -left-8"></div>
                </div>

                <div className={`${stat.color} w-14 h-14 rounded-xl flex items-center justify-center mb-6`}>
                  {stat.icon}
                </div>
                
                <div className="flex items-baseline gap-2 mb-2">
                  <h3 className="text-4xl font-bold font-poppins text-primary-dark">{stat.value}</h3>
                  <div
                  
                  >
                    <ArrowUpRight className="text-primary" />
                  </div>
                </div>
                
                <h4 className="text-xl font-semibold font-poppins text-primary-dark mb-2">{stat.title}</h4>
                <p className="text-gray-600 font-montserrat">{stat.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;